export enum PAGES {
    SUPERDEPORTE_PAGE = 'https://newsletter.superdeporte.com.ec/',
    MEDEPORT_ADIDAS_PAGE = 'https://newsletter-adidas.mundodeportivo-ec.com/',
    MEDEPORT_REEBOOK_PAGE = 'https://newsletter-reebok.mundodeportivo-ec.com/',
    EQUINOX_PAGE = 'https://newsletter.equinox-ec.com/',

}
